import { gql } from '@apollo/client'

export const UPSERT_USER_LOCALE = gql`
  mutation upsertUserLocale($locale: Locales!) {
    upsertUserLocale(locale: $locale) {
      locale
    }
  }
`
